import React from "react";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "../ErrorBoundary/index";

// This component resets the error boundary when route changes
const RouteErrorBoundary = ({ children }) => {
  const location = useLocation();
  const [key, setKey] = React.useState(location.pathname);

  React.useEffect(() => {
    setKey(location.pathname);
  }, [location.pathname]);

  return (
    <ErrorBoundary resetKey={key}>
      {children}
    </ErrorBoundary>
  );
};

export default RouteErrorBoundary;